import { AdvancedTQLFilterDTO } from '@/entities/srm/tql-query/@x/dashboard';
import { DashboardVariableValuesDTO } from '@/entities/dashboards/dashboard/@x/dashboard-widget';
import { z } from 'zod/v4';
import { FilterDTO } from './template';

export const CachedQueryDTO = z.object({
  tab_id: z.string(),
  widget_id: z.string(),
  ci_ids: z.array(z.string()).optional(),
  advanced_tql_params: AdvancedTQLFilterDTO.optional(),
  variable_values: DashboardVariableValuesDTO.optional(),
  params: z.record(z.string(), z.any()).optional(),
  filter: z.array(FilterDTO).optional(),
});

export const CachedPreviewQueryDTO = CachedQueryDTO.omit({
  widget_id: true,
  tab_id: true,
});